// @material-ui
import { makeStyles } from '@material-ui/styles';


export const style = (theme) => ({
  root: {},
  
  card: {
    height: '100%',
    justifyContent: 'space-between'
  },
  
  content: {
    height: 'auto',
    paddingTop: 0,
    
    '&:last-child': {
      paddingBottom: theme.spacing(1.5)
    }
  },
  
  column: {
    display: 'flex',
    flexDirection: 'column'
  },
  
  label: {
    paddingTop: theme.spacing(1.5),
    paddingBottom: 0
  },
  
  value: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start'
  }
});

export const useStyle = makeStyles(style);
